import { useAuth } from "../context/AuthContext";

export function EliteBadge({ user: u, className = "", testid = "vinci-elite-badge", compact = false }) {
  const auth = useAuth();
  const user = u || auth?.user;
  if (!user?.vinci_elite) return null;
  return (
    <span data-testid={testid} title="Vinci Elite · Full Vinci Core Status"
          className={`inline-flex items-center gap-1.5 border border-[#D8B23E] bg-[#D8B23E]/10 text-[#D8B23E] font-grotesk uppercase tracking-[0.28em] ${compact ? "text-[8px] px-2 py-0.5" : "text-[10px] px-3 py-1.5"} ${className}`}>
      <span aria-hidden>◆</span> Vinci Elite
    </span>
  );
}
